import { FaUserCircle } from "react-icons/fa";
import { IoMdStar } from "react-icons/io";
import { FaThumbsUp } from "react-icons/fa";
import { FiMessageCircle } from "react-icons/fi";
import { Paragraph } from "../../basic/title";
import ReviewsSidebar from "./ReviewsSidebar";
import SubmitReviewsfrom from "./SubmitReviewsfrom";
import { useEffect, useState } from "react";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { getReviews, likeReview, } from "../../../../redux/slices/reviews";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const ProductRatings = ({ title }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [likedReviews, setLikedReviews] = useState({});

  const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL;

  const { reviews, totalReviews } = useSelector(
    (state) => state.review
  );

  // Fetch reviews
  useEffect(() => {
    dispatch(getReviews(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (reviews?.length > 0) {
      const userData = localStorage.getItem("user");
      const parsedUser = userData ? JSON.parse(userData) : null;
  
      const likedState = {};
      reviews.forEach((rev) => {
        if (rev.liked_by?.includes(parsedUser?.id)) {
          likedState[rev.id] = true;
        }
      });
      setLikedReviews(likedState);
    }
  }, [reviews]);


  const toggleSection = () => setIsOpen(!isOpen);

  const getParsedImages = (review) => {
    try {
      if (typeof review.images === "string") {
        return JSON.parse(review.images);
      } else if (Array.isArray(review.images)) {
        return review.images;
      }
    } catch (error) {
      console.error("Image parse error:", error);
    }
    return [];
  };

  const handleLike = async (reviewId) => {
    const userData = localStorage.getItem("user");
    const parsedUser = userData ? JSON.parse(userData) : null;
  
    if (!parsedUser?.id) {
      toast.error("Please log in to like/unlike a review.");
      return;
    }
  
    const payload = {
      review_id: reviewId,
      user_id: parsedUser.id,
      product_id: id,
    };
  
    try {
      const res = dispatch(likeReview(payload, toast));
        setLikedReviews((prev) => ({
        ...prev,
        [reviewId]: !prev[reviewId],
      }));
        dispatch(getReviews(id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="border-2 mt-8 w-full border-[#00A762] py-5 px-5 rounded-xl shadow-md mx-auto bg-white">
      <div className="flex sm:flex-row flex-col gap-3 items-center justify-between border-b-2 pb-2 border-[#00A762]">
        <h2 className="font-dm text-xl font-semibold text-[#00A762]">
          Ratings & Reviews ({totalReviews || 0})
        </h2>
        <button
          onClick={toggleSection}
          className="text-sm sm:text-base text-[#00A762] underline hover:text-green-700 transition"
        >
          Submit your Review
        </button>
      </div>

      {isOpen && (
        <div className="p-6 bg-gray-100 rounded-xl mt-4">
          <div className="flex items-center justify-between pb-3 border-b border-gray-300">
            <h2 className="text-xl font-medium text-[#00A762]">Submit Review</h2>
            <div
              className="flex items-center justify-center h-8 w-8 rounded-md bg-[#00A762] cursor-pointer"
              onClick={toggleSection}
            >
              <RxCross2 className="text-white text-xl" />
            </div>
          </div>
          <div className="mt-6">
            <SubmitReviewsfrom id={id} setIsOpen={setIsOpen} />
          </div>
        </div>
      )}

      <div className="mt-8">
        <h3 className="text-lg font-semibold text-[#072320] mb-4">
          {totalReviews > 0 ? "What our customers say" : "No reviews yet"}
        </h3>

        <div className="space-y-6">
          {reviews?.length > 0 ? (
            reviews.slice(0, 4).map((review, index) => {
              const images = getParsedImages(review);

              return (
                <div
                  key={index}
                  className="bg-gray-50 border border-gray-200 rounded-xl p-5 shadow-sm"
                >
                  <div className="flex items-center space-x-4">
                    <FaUserCircle className="text-4xl text-[#00A762]" />
                    <div>
                      <h4 className="font-semibold text-[#072320] text-lg capitalize">
                        {review.firstname || review.username || "Anonymous"}
                      </h4>
                      <p className="text-sm text-gray-500">
                        {dayjs(review.created_at).format("DD MMMM YYYY")}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center mt-3">
                    <span
                      className={`flex items-center text-white text-sm font-semibold px-3 py-1 rounded-full ${
                        review.rating <= 2
                          ? "bg-red-500"
                          : review.rating === 3
                          ? "bg-yellow-500"
                          : "bg-green-600"
                      }`}
                    >
                      {review.rating} <IoMdStar className="ml-1 text-base" />
                    </span>
                  </div>

                  <div className="mt-3 text-sm text-gray-700 leading-relaxed">
                    <Paragraph title={review.comment} textAlign="onyleft" />
                  </div>

                  {images.length > 0 && (
                    <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 gap-3">
                      {images.map((img, i) => (
                        <img
                          key={i}
                          src={`${BASE_IMAGE_URL}${img}`}
                          alt={`Review Image ${i + 1}`}
                          className="w-full h-28 object-cover rounded-md border"
                        />
                      ))}
                    </div>
                  )}

                  {/* Like & Comment */}
                  <div className="flex items-center justify-between mt-4 text-sm text-gray-600">

                    <button
                      onClick={() => handleLike(review.id)}
                      className={`flex items-center gap-1 px-3 py-1 rounded-full text-sm font-medium transition
                        ${likedReviews[review.id] ? "bg-green-100 text-green-600" : "bg-gray-100 text-gray-600"}
                        hover:bg-green-200`}
                    >
                      <FaThumbsUp className={`text-sm ${likedReviews[review.id] ? "text-green-600" : ""}`} />
                      {review.likes_count || 0}
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <p className="text-center text-gray-500">
              No reviews found for this product.
            </p>
          )}
        </div>
      </div>

      <div className="mt-6">
        <ReviewsSidebar title={title} reviews={reviews} />
      </div>
    </div>
  );
};

export default ProductRatings;
